import { Box } from '@mui/material'
import { FC } from 'react'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'

interface DmsOptimizationCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
}

const DmsOptimizationCell: FC<DmsOptimizationCellProps> = ({ params }) => {
  const { isParent } = params?.row ?? {}

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {isParent ? (
        <Box
          key={`dms-opts-${params?.value}`}
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            width: '100%',
            height: '100%',
          }}
        >
          {params?.value}
        </Box>
      ) : (
        '–'
      )}
    </Box>
  )
}
export default DmsOptimizationCell
